import React, { Component } from "react";

import { ListGroup, ListGroupItem, Image } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import UsersService from "../../services/users-service";

//props
//currentPage
class PlaceholderPage extends Component {

  render() {
    return <div style={{height: 800, width: "100%", backgroundColor: "white", flexDirection: 'row', flex: 1, fontSize: 20}}>
              <center style={{paddingTop: "30%"}}>{this.props.currentPage} page in Progress! ¯\_(ツ)_/¯</center>
            </div>
  }
}

export default PlaceholderPage;
